import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceLiveViewComponent } from './device-live-view/device-live-view.component';
import {DxButtonModule} from "devextreme-angular";
import {I18NextModule} from "angular-i18next";
import {SharedModule} from "../shared/shared.module";
import {SvgIconComponent} from "angular-svg-icon";
import {OutputIconPipe} from "../units/pipes/output-icon.pipe";



@NgModule({
  declarations: [
    DeviceLiveViewComponent,
    OutputIconPipe
  ],
  imports: [
    CommonModule,
    DxButtonModule,
    I18NextModule,
    SharedModule,
    SvgIconComponent
  ],
  exports: [
    DeviceLiveViewComponent
  ]
})
export class LiveViewModule { }
